<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.tags-administration.title"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <div class="d-flex">
      <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
      <app-search-field *ngIf="selectedClient"
                        (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}"
                    [(checked)]="showInactive"
                    *ngIf="selectedClient"
                    cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>

<div class="control-section"
     *ngIf="selectedClient">
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [filterSettings]="filterSettings"
            [allowFiltering]="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [editSettings]="editSettings"
            [searchSettings]="searchOptions"
            (actionComplete)="actionComplete($event)"
            (actionBegin)="actionBegin($event)">
    <e-columns>
      <e-column field="id"
                [visible]="false"
                headerText="id"
                [isPrimaryKey]="true"></e-column>
      <e-column field="identificationCode"
                type="string"
                headerText="{{'i18n.domain.tags-administration.grid.identificationCode' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="barcode"
                type="string"
                headerText="{{'i18n.domain.tags-administration.grid.barcode' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="countryCode"
                type="string"
                headerText="{{'i18n.domain.tags-administration.grid.countryCode' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="controlPlateType"
                headerText="{{'i18n.domain.tags-administration.grid.controlPlateType' | translate}}"
                [filter]="checkBoxFilter"
                clipMode="EllipsisWithTooltip">
        <ng-template #filterItemTemplate let-data>{{formatControlPlateType(data) | translate}}</ng-template>
        <ng-template #template let-data>
          {{formatControlPlateType(data) | translate}}
        </ng-template>
      </e-column>
      <e-column field="controlPlateNumber"
                type="string"
                headerText="{{'i18n.domain.tags-administration.grid.controlPlateNumber' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          <span class="text-uppercase">{{data.controlPlateNumber | translate}}</span>
        </ng-template>
      </e-column>
      <e-column field="description"
                type="string"
                headerText="{{'i18n.domain.tags-administration.grid.description' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="enableAutomaticPlateRecognitionParking"
                headerText="{{'i18n.domain.tags-administration.grid.enableAutomaticPlateRecognitionParking' | translate}}"
                [defaultValue]="false"
                [filter]="enableAutomaticPlateRecognitionParkingFilter">
        <ng-template #template let-data>
        <span class="e-icons"
              [class.icon-checkmark]="data.enableAutomaticPlateRecognitionParking"></span>
        </ng-template>
      </e-column>
      <e-column field="modifiedOn"
                headerText="{{'i18n.domain.tags-administration.grid.modifiedOn' | translate}}">
        <ng-template #template let-data>
          {{data.modifiedOn | date: 'dd.MM.yyyy HH:mm:ss'}}<br>
        </ng-template>
      </e-column>
      <e-column field="modifiedBy"
                headerText="{{'i18n.domain.tags-administration.grid.modifiedBy' | translate}}">
      </e-column>
      <e-column field="defect"
                headerText="{{'i18n.domain.tags-administration.grid.defect' | translate}}"
                width="160px"
                [visible]="showInactive"
                [defaultValue]="false"
                [filter]="isDefectFilter">
        <ng-template #template let-data>
        <span class="e-icons"
              [class.icon-checkmark]="data.defect"></span>
        </ng-template>
      </e-column>
      <e-column field="active"
                headerText="{{'i18n.shared.fields.active' | translate}}"
                width="160px"
                [visible]="showInactive"
                [defaultValue]="true"
                [filter]="isActiveFilter">
        <ng-template #filterItemTemplate
                     let-data>{{formatIsActive(data, 'active')}}</ng-template>
        <ng-template #template
                     let-data>
          <span class="e-icons"
                [class.icon-checkmark]="data.active"></span>
        </ng-template>
      </e-column>
      <e-column headerText=""
                [commands]="gridCommands"
                width="120px"></e-column>
    </e-columns>
  </ejs-grid>
</div>
